import Text from 'components/Text';
import { useIsEditing } from 'hooks';
import { cn } from 'utils/classNames';
import { is } from 'utils/helpers';

interface Props {
	className?: string;
	componentName: string;
	deprecated?: boolean | string;
	description?: string;
}

export function ComponentPlaceholderBox({
	className,
	componentName,
	deprecated,
	description,
}: Props) {
	return (
		<div
			className={cn(
				className,
				'flex min-h-40 w-full flex-col justify-center p-8',
				deprecated ? 'bg-error' : 'bg-subtle',
			)}
		>
			<Text as="h2" styleAs="h1" className="text-center">
				{componentName}
			</Text>
			{!deprecated && description && (
				<Text as="p" className="mt-1 text-center">
					{description}
				</Text>
			)}
			{deprecated && (
				<Text as="p" className="mt-1 text-center font-bold">
					This component is deprecated and should be removed from the page.
					{is.string(deprecated) && ` ${deprecated}`}
				</Text>
			)}
		</div>
	);
}
ComponentPlaceholderBox.displayName = 'ComponentPlaceholder';

/** Box to display in experience editor when required data for a component is missing. Renders nothing on the site. */
export default function ComponentPlaceholder(props: Props) {
	const isEditing = useIsEditing();

	if (!isEditing) {
		return null;
	}

	return <ComponentPlaceholderBox {...props} />;
}
ComponentPlaceholder.displayName = 'ComponentPlaceholder';
